import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { sendEvent } from "./B2BUserNav.utils.esm.js";
import { usePageProps } from "@zillow/cms-utils";
const menuItemStyles = css({
  paddingBlock: "tightest",
  paddingInline: "default",
  listStyle: "none",
  _hover: {
    backgroundColor: "blue.50"
  }
});
const anchorStyles = css({
  textStyle: "body-sm",
  color: "text.accent.brand.hero",
  textDecoration: "none",
  _hover: {
    textDecoration: "underline"
  }
});
const TextButtonAnchor = ({
  children,
  ...props
}) => /* @__PURE__ */ jsx("a", { className: anchorStyles, ...props, children });
const SignOut = ({
  dropdown,
  url,
  userMenuItems
}) => {
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const menuItems = [...userMenuItems || [], {
    label: "Sign out",
    url
  }];
  return /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    position: "absolute",
    display: dropdown ? "block" : "none",
    top: "calc(100% + 4px)",
    right: "calc(token(spacing.tighter) * -1)",
    margin: 0,
    minWidth: "calc(token(spacing.loose) * 5)",
    padding: 0,
    backgroundColor: "bg.neutral",
    borderRadius: "obj.default",
    boxShadow: "md",
    textStyle: "body",
    zIndex: "popover",
    overflow: "hidden"
  }, children: /* @__PURE__ */ jsx("ul", { "aria-hidden": !dropdown, children: menuItems.map((item) => /* @__PURE__ */ jsx("li", { className: menuItemStyles, children: /* @__PURE__ */ jsx(TextButtonAnchor, { href: item.url, onClick: yieldCallback(() => {
    sendEvent("cms_anchor", item.label, item.url, cmsInfo);
  }), children: item.label }) }, item.label)) }) });
};
export {
  SignOut as default
};
